module.exports = __webpack_public_path__ + "img/basicrender.c75e49ea.png";